/* eslint-disable
    array-callback-return,
    no-prototype-builtins,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./simpleCheckbox.scss');

const deps = [];

module.exports = angular
  .module('bench.ui.simpleCheckbox', deps)

  .directive('blSimpleCheckbox', _ => {
    let $$id = 0;
    return {
      restrict: 'E',
      scope: false,
      require: '?ngModel',
      template(elem, attrs) {
        // set defaults
        _.defaults(attrs, {
          name: _.camelCase(attrs.name),
          type: 'checkbox',
        });

        // attrs that go into input
        const inputAttrs = _(
          [
            'id',
            'name',
            'type',
            'ng-model',
            'ng-checked',
            'checked',
            'readonly',
            'ng-readonly',
            'ng-change',
            'ng-click',
            'ng-true-value',
            'ng-false-value',
          ].map(attr => {
            if (attrs.hasOwnProperty(_.camelCase(attr))) {
              const attrVal = attrs[_.camelCase(attr)];
              elem.removeAttr(attr);
              if (!_.isEmpty(attrVal)) {
                return `${attr}=\"${attrVal}\"`;
              }
              return attr;
            }
          }),
        )
          .compact()
          .join('\n');

        return `\
<input ${inputAttrs}>
<label><span class="bl-icon-checkmark bl-simple-checkbox-checked"></span></label>\
`;
      },
      link(scope, elem, attrs, ngModel) {
        const $input = elem.find('input');
        const $label = elem.find('label');

        const $id = `bl-simple-checkbox-${$$id++}`;

        $input.attr('id', $id);
        $label.attr('for', $id);
        if (attrs.ngChecked) {
          return scope.$watch(attrs.ngChecked, (newVal, oldVal) => {
            if (oldVal === newVal) {
              return;
            }
            return ngModel.$setViewValue(newVal);
          });
        }
      },
    };
  });
